<template>
  <v-dialog v-model="show"
            :width="dialogWidth"
            scrollable
            persistent
  >
    <v-sheet>
      <v-toolbar>
        <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>

        <v-spacer />
      </v-toolbar>

      <v-divider />

      <v-card-text>
        <v-sheet class="my-3 font-weight-bold">
          ■ (필수) 개인정보 수집∙이용에 대한 동의
        </v-sheet>

        <v-container fluid class="grid-table">
          <v-row>
            <v-col cols="3">
              수집·이용하는 개인정보 항목
            </v-col>
            <v-col cols="9">
              성명, 성별, 생년월일, 휴대폰번호, 이메일, 비상연락처, 주소, 학력사항, 가족사항, 이력사항, 자격사항, 자기소개서, 임시저장
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              개인정보의 수집 및 이용목적
            </v-col>
            <v-col cols="9">
              본인 확인, 채용 적합성 판단 및 서류 심사∙면접, 지원자 채용 및 지원자의 채용 관련 안내, 공지사항 전달, 회사의 인재 DB 활용
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              개인정보의 보유 및 이용기간
            </v-col>
            <v-col cols="9">
              개인정보 수집 동의일부터 3년간
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              동의 거부권 및 동의 거부에 따른 불이익 내용 또는 제한사항
            </v-col>
            <v-col cols="9">
              지원자는 개인정보 수집·이용에 대한 동의를 거부할 권리를 보유합니다. 그러나 동의를 거부하시는 경우 채용절차가 취소될 수 있습니다.
            </v-col>
          </v-row>
        </v-container>

        <v-sheet class="my-3 font-weight-bold d-flex">
          <v-sheet>(필수) 개인정보 수집∙이용에 동의하십니까?</v-sheet>

          <v-spacer />
          <v-radio-group v-model="pi_agree"
                         class="ma-0 pa-0"
                         hide-details
                         row
          >
            <v-radio label="동의함" value="Y" />
            <v-radio label="동의하지 않음" value="N" />
          </v-radio-group>
        </v-sheet>

        <v-sheet class="my-3 font-weight-bold">
          ■ (필수) 개인정보 제3자 제공에 대한 동의
        </v-sheet>

        <v-container fluid class="grid-table">
          <v-row>
            <v-col cols="3">
              제공받는 자
            </v-col>
            <v-col cols="9">
              채용된 오렌즈 가맹점
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              제공받는 자의 목적
            </v-col>
            <v-col cols="9">
              채용 점주의 채용자 이력서 및 자기소개서 확인, 채용계약 체결
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              제공항목
            </v-col>
            <v-col cols="9">
              성명, 성별, 생년월일, 휴대폰번호, 이메일, 비상연락처, 주소, 학력사항, 가족사항, 이력사항, 자격사항, 자기소개서, 임시저장
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              제공받는 자의 개인정보 보유 및 이용기간
            </v-col>
            <v-col cols="9">
              채용계약 종료일까지<br>
              ※ 단, 관계법령에 의한 정보 보유의 경우 해당 법령에서 명시한 기간 동안 보유합니다.
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              동의 거부권 및 동의 거부에 따른 불이익 내용 또는 제한사항
            </v-col>
            <v-col cols="9">
              지원자는 개인정보 제3자 제공에 대한 동의를 거부할 권리를 보유합니다. 그러나 동의를 거부하시는 경우 채용절차가 취소될 수 있습니다.
            </v-col>
          </v-row>
        </v-container>

        <v-sheet class="my-3 font-weight-bold d-flex">
          <v-sheet>(필수) 개인정보 수집∙이용에 동의하십니까?</v-sheet>

          <v-spacer />
          <v-radio-group v-model="tp_agree"
                         class="ma-0 pa-0"
                         hide-details
                         row
          >
            <v-radio label="동의함" value="Y" />
            <v-radio label="동의하지 않음" value="N" />
          </v-radio-group>
        </v-sheet>
      </v-card-text>

      <v-sheet class="text-center font-weight-bold">
        「개인정보 보호법」등 관련 법규에 의거 상기 본인은 위와 같이 개인정보의 수집 및 이용과 제3자 제공 동의 여부에 위와 같이 의사를 표시함.
      </v-sheet>

      <v-card-actions>
        <v-spacer />

        <v-btn color="secondary" depressed @click="disagree">
          취소
        </v-btn>
        <v-btn color="primary" depressed @click="agree">
          동의하고 지원서 작성
        </v-btn>
      </v-card-actions>
    </v-sheet>
  </v-dialog>
</template>

<script>

export default {
  name: 'PrivacyDialog',
  props: {
    value: { type: Boolean, default: false },
    dialogTitle: { type: String, default: '[ 개인정보 수집∙이용, 제3자 제공 동의서 ]' },
    dialogWidth: { type: Number, default: 1280 },
  },
  data: () => ({
    pi_agree: null, // 개인정보 동의 Personal Information Agreement
    tp_agree: null, // 제3자 제공 동의 Release of information to a third party
  }),
  computed: {
    show: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    disagree () {
      window.location.href = 'http://www.starvision8800.com/default/m5/s4.php?m=5&sm=53';
    },
    agree () {
      if (this.pi_agree !== 'Y' || this.tp_agree !== 'Y') {
        this.$dialog.message.warning('개인정보 수집∙이용 및 제3자 제공에 모두 동의 하셔야 지원이 가능합니다.');
        return;
      }

      this.show = false;
    },
  },
};
</script>

<style scoped>

</style>
